import { createContext } from '@lit/context';

export interface PreviewState {
  previewAnimationStarted: boolean;
  previewAnimationEnded: boolean;
  startPreviewAnimation: () => void;
  endPreviewAnimation: () => void;
}

export const previewAnimationContext = createContext<PreviewState>('previewAnimationContext');
